import { webApi } from "../../../../core/http/httpThunks";
import { OrderIndData } from "../types";

export const getOrderIndApi = (userId: string, ordindid: number) =>
  webApi<OrderIndData>({
    method: "GET",
    url: "order/getorderindicative",
    params: {
      userId,
      ordindid,
    },
  });

export default getOrderIndApi;
